import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Card } from "../";
/**
 * @class TravelPlan
 * @classdesc Class definition for the record type from model
 * @param {OBJECT} record - The record from the model to init class
 * @extends BCMSRecord
 * @example new TravelPlan(model.travelPlans[0]);
 * 
 * @property {NUMBER} _id - The id of the travel plan
 * @property {bcmsDate} _departDate - The date of the departure date
 * @property {bcmsDate} _returnDate - The date of the return date
 * @property {STRING} _status - The status of the travel plan
 */
export default class TravelPlan extends BCMSRecord {
    _id;
    _departDate;
    _returnDate;
    _status;
    _trip;
    _card;

    constructor(record) {
        super(record);
    }
}

TravelPlan.define({
    "recordType" : "travelPlans",
    "recordIDProp" : "id",
    "className": "TravelPlan",
    "recordProperties" : [
        /**
         * @name id
         * @instance
         * @property get {STRING} - gets the id of the travel plan
         * @property set {STRING} - sets the id of the travel plan
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToString("id", "_id"),

        /**
         * @name departDate
         * @instance
         * @property get {bcmsDate} - gets the depart date
         * @property set {bcmsDate} - sets the depart date
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToDate("departDate", "_departDate"),

        /**
         * @name returnDate
         * @instance
         * @property get {bcmsDate} - gets the return date
         * @property set {bcmsDate} - sets the return date
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToDate("returnDate", "_returnDate"),

        /**
         * @name status
         * @instance
         * @property get {STRING} - gets the status of the travel plan
         * @property set {STRING} - sets the status of the travel plan
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToString("status", "_status"),

        /**
         * @name trip
         * @instance
         * @property get {trip} - gets the Trip of the travel plan
         * @property set {trip} - sets the Trip of the travel plan
         * @memberof TravelPlan
         */
         BCMSRecordProperty.mapToString("trip", "_trip"),

         /**
          * @name card
          * @instance
          * @property get {card} - Gets the card the travel plan is related to
          * @property set {card} - Sets the card the travel plan is releated to
          * @memberof TravelPlan
          */
         BCMSRecordProperty.mapToClass("card", "_card", () => Card)
    ]
});